/**
 * AdminTopbar - top bar for admin (mobile sheet drawer)
 */
import { Menu, Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/brand";
import AdminSidebar from "./AdminSidebar";

export default function AdminTopbar() {
    return (
        <header
            className="sticky top-0 z-30 backdrop-blur-md bg-background/80 border-b border-border h-16 flex items-center px-4 sm:px-6 gap-3"
            data-testid="admin-topbar"
        >
            <Sheet>
                <SheetTrigger asChild className="lg:hidden">
                    <Button variant="ghost" size="icon" data-testid="admin-mobile-menu">
                        <Menu className="h-5 w-5" />
                    </Button>
                </SheetTrigger>
                <SheetContent side="left" className="p-0 w-[280px] dark bg-background">
                    <div className="dark min-h-full bg-background">
                        <AdminSidebar />
                    </div>
                </SheetContent>
            </Sheet>

            <Link to="/admin" className="lg:hidden flex items-center gap-2">
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-[#0B0B10] overflow-hidden">
                    <img src={LOGO_URL} alt="MeSafa" className="h-8 w-8 object-contain" />
                </span>
                <span className="font-display font-bold text-base">
                    <span className="text-[#A78BFA]">me</span>Safa
                </span>
            </Link>

            <div className="flex-1" />

            <Button variant="ghost" size="icon">
                <Bell className="h-4 w-4" />
            </Button>
        </header>
    );
}
